import "./App.css";

import { useEffect, useRef, useState } from "react";
import Scene01 from "./scenes/Scene01";
import Scene02 from "./scenes/Scene02";
import Scene03 from "./scenes/Scene03";
import Scene04 from "./scenes/Scene04";
import Scene05 from "./scenes/Scene05";
import Scene06 from "./scenes/Scene06";

const sceneImages = [
  "/images/scene-01.png",
  "/images/scene-02.png",
  "/images/scene-03.png",
  "/images/scene-04.png",
  "/images/scene-05.png",
  "/images/scene-06.png",
];

function App() {
  const [scene, setScene] = useState(1);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    const preloadImages = async () => {
      await Promise.all(
        sceneImages.map(
          (src) =>
            new Promise((resolve) => {
              const img = new Image();

              img.onload = resolve;
              img.onerror = resolve;

              img.src = src;
            }),
        ),
      );

      if (mounted) {
        setImagesLoaded(true);
      }
    };

    preloadImages();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (scene > 1 && audioRef.current) {
      audioRef.current.play().catch(() => {
        // Autoplay dapat diblokir browser pada kondisi tertentu.
      });
    }
  }, [scene]);

  const handleNext = () => {
    setScene((prev) => prev + 1);
  };

  if (!imagesLoaded) {
    return (
      <div className="flex min-h-[100dvh] w-full items-center justify-center bg-black">
        <p className="font-playful text-xl font-bold text-white">
          Preparing your surprise... 💕
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-[100dvh] w-full overflow-hidden bg-black">
      <div className="relative mx-auto h-[100dvh] w-full max-w-[430px] overflow-hidden">
        {scene > 1 && (
          <audio
            ref={audioRef}
            src="/audio/scene-02.mp3"
            autoPlay
            loop
            preload="auto"
          />
        )}

        {scene === 1 && <Scene01 onNext={handleNext} />}
        {scene === 2 && <Scene02 onNext={handleNext} />}
        {scene === 3 && <Scene03 onNext={handleNext} />}
        {scene === 4 && <Scene04 onNext={handleNext} />}
        {scene === 5 && <Scene05 onNext={handleNext} />}
        {scene === 6 && <Scene06 />}
      </div>
    </div>
  );
}

export default App;
